import React from "react";
import { Button, Checkbox, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DateInput from "@_components/DateInput/DateInput";
import TextfieldInputSmall from "@_components/TextfieldInput/TextfieldInputSmall";
import styles from "../MailPopup.module.css";

/**
 * Presentational reminder UI: the "set reminder" checkbox, the interval
 * menu, the optional custom date picker and the reminder name field. All
 * state and handlers are owned by useReminderState; this is a pure move of
 * the markup that previously lived inline in MailPopup.
 */
function ReminderControls({
  doSaveDeadline,
  setReminderChecked,
  reminderMenuOpen,
  handleOpenReminderMenu,
  handleCloseReminderMenu,
  reminderSetting,
  handleChangeReminderOption,
  showDatePicker,
  reminderDate,
  setReminderDate,
  reminderMinDate,
  reminderName,
  setReminderName,
}) {
  return (
    <div className={styles.reminder_container}>
      <Checkbox
        className={styles.reminder_container_content}
        checked={doSaveDeadline}
        onChange={setReminderChecked} // todo seems wrong
      ></Checkbox>
      <div
        style={{ marginTop: 12 }}
        className={styles.reminder_container_content}
      >
        set reminder
      </div>

      <Button
        style={{ marginTop: 5, marginLeft: 12 }}
        variant="outlined"
        className={styles.reminder_container_content}
        onClick={handleOpenReminderMenu}
        endIcon={<ArrowDropDownIcon />}
      >
        {
          <div className={styles.menu_item}>
            {" "}
            <p className={styles.menu_item_span}>{reminderSetting}</p>
          </div>
        }
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={reminderMenuOpen}
        keepMounted={false}
        open={Boolean(reminderMenuOpen)}
        onClose={handleCloseReminderMenu}
      >
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption(3)}
        >
          <div className={styles.menu_item}>
            <p>in 3 days</p>{" "}
          </div>
        </MenuItem>
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption(5)}
        >
          <div className={styles.menu_item}>
            <p>in 5 days</p>{" "}
          </div>
        </MenuItem>
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption(7)}
        >
          <div className={styles.menu_item}>
            <p>in 7 days</p>{" "}
          </div>
        </MenuItem>
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption(14)}
        >
          <div className={styles.menu_item}>
            <p>in 14 days</p>{" "}
          </div>
        </MenuItem>
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption(30)}
        >
          <div className={styles.menu_item}>
            <p>in 30 days</p>{" "}
          </div>
        </MenuItem>
        <MenuItem
          className={styles.email_setup_dropdown}
          onClick={() => handleChangeReminderOption("custom")}
        >
          <div className={styles.menu_item}>
            <p>custom</p>{" "}
          </div>
        </MenuItem>
      </Menu>
      {showDatePicker && (
        <DateInput
          style={{
            width: 150,
            display: "inline-block",
            float: "left",
            marginLeft: 12,
            marginTop: 5,
          }}
          label="Date"
          id="reminder_date"
          name="reminder_date"
          value={reminderDate}
          onChange={(date) => setReminderDate(date)}
          minDate={reminderMinDate}
        />
      )}
      <div
        style={{ marginTop: 12, marginLeft: 12, marginRight: 12 }}
        className={styles.reminder_container_content}
      ></div>
      <TextfieldInputSmall
        style={{
          width: 180,
          display: "inline-block",
          float: "left",
          marginTop: "5px",
        }}
        label="Name"
        id="reminder_title"
        name="reminder_title"
        type="string"
        value={reminderName}
        onChange={(event) => setReminderName(event.target.value)}
      />
    </div>
  );
}

export default ReminderControls;
